import Api from '@/services/Api'

export default {
    getAllMaterials(){
        return Api().get('tipo-material')
    },
    updateMaterial (id) {
      return Api().put('tipo-material/'+ id)
    },
    deleteMaterial (id) {
      return Api().put('tipo-material/'+ id + "/delete")
    },
    createMaterial (form){
      return Api().post('tipo-material/create', form)
    }
  }
  